export const OPERATORS_DATE = [
    { value: '=', label: 'Is Equal to' },
    { value: '!=', label: 'Is NOT Equal to' },
    { value: 'is null', label: 'Is Blank' },
    { value: 'is not null', label: 'Is Not Blank' },
    { value: '<', label: 'Is earlier than' },
    { value: '<=', label: 'Is earlier than or equal to' },
    { value: '>', label: 'Is later than' },
    { value: '>=', label: 'Is later than or equal to' },
    { value: 'this_week', label: 'This Week', igoring_year: true },
    { value: 'last_week', label: 'Last Week', igoring_year: true },
    { value: 'this_month', label: 'This Month', igoring_year: true },
    { value: 'last_month', label: 'Last Month', igoring_year: true },
    { value: 'last_n_days', label: 'In the last n Days', igoring_year: true },
    { value: 'not_last_n_days', label: 'Not in the last n Days', igoring_year: true },
    { value: 'today', label: 'Today', igoring_year: true },
    { value: 'next_month', label: 'Next Month', igoring_year: true },
    { value: 'last_n_months', label: 'Last n Months', igoring_year: true },
    { value: 'next_n_months', label: 'Next n Months', igoring_year: true },
    { value: 'not_last_n_months', label: 'Not in the last n Months', igoring_year: true },
    { value: 'next_week', label: 'Next Week', igoring_year: true },
    { value: 'next_n_days', label: 'Next n Days', igoring_year: true },
];

export const OPERATORS_N = [
    'last_n_days_ignoring_year',
    'last_n_days',
    'last_n_months_ignoring_year',
    'last_n_months',
    'next_n_days_ignoring_year',
    'next_n_days',
    'next_n_months_ignoring_year',
    'next_n_months',
    'not_last_n_days_ignoring_year',
    'not_last_n_days',
    'not_last_n_months_ignoring_year',
    'not_last_n_months',
];

export const OPERATORS_THAT_DONT_NEED_VALUE = [
    'is null',
    'is not null',
    '= 1',
    '= 0',
    'this_week',
    'last_week',
    'this_month',
    'last_month',
    'today',
    'next_week',
    'next_month',
    'this_week_ignoring_year',
    'last_week_ignoring_year',
    'this_month_ignoring_year',
    'last_month_ignoring_year',
    'today_ignoring_year',
    'next_week_ignoring_year',
    'next_month_ignoring_year',
];

export const makeId = () => {
    return -1 * Math.floor(Math.random() * 999999);
};

export const makeFilter = () => {
    return {
        id: makeId(),
        attribute_name: null,
        data_type: null,
        key: null,
        operator: null,
        value: null,
    };
};

export const makeGroup = () => {
    return {
        id: makeId(),
        filters: [makeFilter()],
    };
};
